export default __webpack_public_path__ + "static/media/Graphics_front-min.eb12d6c1.jpg";